<div class="ws-flex-container-vertical ws-flex-auto">
    <ws-bread-crumbs
        [breadcrumbs]="breadcrumbs"
        style="height: 30px"
        [currentPageTitle]="referral?.matterId?.toString() ?? ''"
    ></ws-bread-crumbs>
    <div class="ws-section">
        <div class="ws-section__header pt-3 border-bottom-0">
            <h4 class="ws-section__header__title page-title"> Litigation Referral </h4>
            <div class="ws-section__header__actions">
                @if (referral) {
                    <div class="ws-section__header__actions__item">
                        <strong>Status:</strong>
                        <a style="cursor: pointer; margin-left: 8px" (click)="launchTaskModal($event)">
                            {{ taskStatusName }}
                        </a>
                    </div>
                    @if (workflowStatus() && hasWritePermission) {
                        <div class="ws-section__header__actions__item">
                            <button
                                type="button"
                                [disabled]="editMode() || enteringEditMode || !workflowStatus().canAdvanceTask"
                                class="ace-btn btn-sm btn-primary"
                                data-qa="referral-advance-task"
                                (click)="advanceTask()"
                            >
                                {{ taskAdvanceName }}
                            </button>
                            <button
                                type="button"
                                (click)="launchExceptionModal()"
                                tooltip="Exception"
                                [disabled]="
                                    editMode() ||
                                    enteringEditMode ||
                                    (!workflowStatus().canSkipTask &&
                                        !workflowStatus().canReassignTask &&
                                        !workflowStatus().canRescindTask)
                                "
                                class="ace-btn btn-sm btn-primary btn-danger"
                                data-qa="referral-task-exception"
                            >
                                Exception
                            </button>
                            @if (isBatchMode) {
                                <button
                                    type="button"
                                    [tooltip]="taskIndex < taskList.length - 1 ? 'Skip Referral' : 'Close Referral'"
                                    (click)="skipReferral()"
                                    [disabled]="editMode() || enteringEditMode"
                                    class="ace-btn btn-sm btn-secondary"
                                    data-qa="referral-batch-skip"
                                >
                                    {{ taskIndex < taskList.length - 1 ? 'Skip' : 'Close' }}
                                </button>
                            }
                        </div>
                        @if (canModifyReferral) {
                            <div class="ws-section__header__actions__item">
                                @if (!editMode()) {
                                    <button
                                        type="button"
                                        [disabled]="enteringEditMode"
                                        class="ace-btn btn-sm has-icon btn-primary"
                                        data-qa="referral-edit"
                                        helpTooltip
                                        helpContentId="app.edit"
                                        (click)="edit()"
                                    >
                                        @if (enteringEditMode) {
                                            <ws-ace-loader [inline]="true"></ws-ace-loader>
                                        } @else {
                                            <i class="fa fa-pencil"></i>
                                        }
                                    </button>
                                } @else {
                                    <button
                                        type="button"
                                        helpTooltip
                                        helpContentId="app.save"
                                        data-qa="referral-save"
                                        (click)="save()"
                                        class="ace-btn btn-sm has-icon btn-primary"
                                    >
                                        <i class="fa fa-save"></i>
                                    </button>
                                    <button
                                        type="button"
                                        class="ace-btn btn-sm has-icon btn-primary btn-danger"
                                        data-qa="referral-cancel"
                                        helpTooltip
                                        helpContentId="app.cancel"
                                        (click)="cancelEdit()"
                                    >
                                        <i class="fa fa-close"></i>
                                    </button>
                                }
                            </div>
                        }
                    }
                }
                <div class="ws-section__header__actions__item">
                    <entity-attachments
                        [(hasAttachments)]="hasAttachments"
                        buttonClass="ace-btn btn-primary btn-sm"
                        [modalData]="attachmentModalData"
                        (allAttachmentsChange)="onAllAttachmentsChanged($event)"
                        helpTooltip
                        helpContentId="app.attachments"
                    >
                    </entity-attachments>
                    <entity-comments
                        [(hasComments)]="hasComments"
                        buttonClass="ace-btn btn-primary btn-sm"
                        [modalData]="commentModalData"
                        helpTooltip
                        helpContentId="app.comments"
                    >
                    </entity-comments>
                </div>
                <div class="ws-section__header__actions__item">
                    <div class="action-button-wrapper">
                        <button
                            type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            [disabled]="editMode() || enteringEditMode"
                            (click)="refresh()"
                            helpTooltip
                            helpContentId="app.refresh"
                        >
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ws-section position-relative">
        <referral-overview
            [referral]="referral"
            [systemReferral]="systemReferral"
            [originalReferral]="originalReferral"
            [form]="referralForm"
        ></referral-overview>
        @if (referral) {
            <referral-site-details
                #siteDetails
                [systemReferral]="systemReferral"
                [originalReferral]="originalReferral"
                [(referral)]="referral"
                [form]="referralForm"
                (onSaveError)="resetForm()"
                (onAppealAddRemove)="refresh()"
            >
            </referral-site-details>
        }
        <div class="row row-cols-2" style="margin-bottom: 20px">
            <div class="col d-flex">
                <referral-client-info
                    [systemReferral]="systemReferral"
                    [originalReferral]="originalReferral"
                    [referral]="referral"
                    [form]="referralForm"
                >
                </referral-client-info>
            </div>
            <div class="col">
                <div class="row">
                    <div class="col">
                        <div class="card panel-flat-color primary-panel">
                            <div class="panel-flat-header">
                                <h3>Plaintiff</h3>
                            </div>
                            <div
                                class="panel-flat-body position-relative"
                                style="min-height: initial"
                                [formGroup]="referralForm"
                            >
                                <div class="referral-field-grid">
                                    <label class="referral-field-label" for="plaintiffAssessees"
                                        >Taxpayer/Plaintiff</label
                                    >
                                    <referral-input-with-revert
                                        formControlName="plaintiffAssessees"
                                        [systemValue]="systemReferral?.plaintiffAssessees"
                                        [originalValue]="originalReferral?.plaintiffAssessees"
                                        [maxlength]="8000"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <referral-routing
                            style="display: block"
                            [systemReferral]="systemReferral"
                            [originalReferral]="originalReferral"
                            [form]="referralForm"
                            [coCounselFirmOptions]="coCounselFirmOptions"
                        >
                        </referral-routing>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <referral-service-provider-fees
                            style="display: block"
                            [systemReferral]="systemReferral"
                            [originalReferral]="originalReferral"
                            [referral]="referral"
                            [form]="referralForm"
                        >
                        </referral-service-provider-fees>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex">
                <referral-scope-of-appeal
                    [systemReferral]="systemReferral"
                    [originalReferral]="originalReferral"
                    [referral]="referral"
                    [form]="referralForm"
                >
                </referral-scope-of-appeal>
            </div>
            <div class="col d-flex">
                <referral-value-assessments
                    class="d-flex"
                    [systemReferral]="systemReferral"
                    [referral]="referral"
                    [originalReferral]="originalReferral"
                    [form]="referralForm"
                >
                </referral-value-assessments>
            </div>
        </div>
        <referral-ryan-contacts
            [systemReferral]="systemReferral"
            [originalReferral]="originalReferral"
            [referral]="referral"
            [form]="referralForm"
        >
        </referral-ryan-contacts>
        <div class="referral-field-grid" [formGroup]="referralForm">
            <label class="referral-field-label" [style.margin-bottom.px]="editMode() ? 47 : 0" for="additionalNotes">
                Additional Notes
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="additionalNotes"
                [systemValue]="systemReferral?.additionalNotes"
                [originalValue]="originalReferral?.additionalNotes"
                [isTextArea]="true"
                [maxlength]="8000"
            />
        </div>
    </div>
</div>
